module.exports = __webpack_public_path__ + "static/media/sempre-design.d8c4d371.png";